import { IPageInSearch } from '@/shared/searchProvider';
import { normalizeSitemapProperty, normalizeUri } from '../utils';
import { IRingSearchItem } from './types';

const FNV_PRIME = 0x01000193;
const FNV_OFFSET = 0x811c9dc5;

const stableHash32 = (input: string): number => {
  let hash = FNV_OFFSET;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return hash >>> 0;
};

class RingSearchPageService {
  transform(item: IRingSearchItem): IPageInSearch {
    const payload = item.payload ?? ({} as IRingSearchItem['payload']);
    const url = payload.url || '';

    return {
      imageUrl: payload.logoUrl || '',
      name: normalizeSitemapProperty(payload.title || ''),
      description: normalizeSitemapProperty(payload.description || ''),
      path: normalizeUri(url),
      pageId: stableHash32(url),
      vanityUrl: '',
    };
  }
}

export const ringSearchPageService = new RingSearchPageService();
